module.exports = __webpack_public_path__ + "img/hero-check.1d7c9ed9.svg";